import { defineAsyncComponent } from 'vue';

const taxRateChangeNotification = defineAsyncComponent(() =>
  import('@/views/notification/taxRate/TaxRateChangeNotification.vue')
);

const notificationDetail = defineAsyncComponent(() =>
  import('@/layouts/NotificationDetail.vue')
);

export function registerNotification(app) {
  app.component('TaxRateChangeNotification', taxRateChangeNotification);
  app.component('NotificationDetail', notificationDetail);
}
